import React from 'react';
import { ListContainer, ErrorMessageTop } from 'src/domains/layouts/shared/cms/list/List.style';
import { SingleBanner } from './SingleBanner';
import { CasinoBannersDataState } from 'src/AppState/CmsState/CasinoBannersDataState/CasinoBannersData.state';
import { observer } from 'src/utils/mobx-react';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';
import { CasinoBannerType } from 'src/domains/casino/models/models';

interface PropsType {
    casinoBannersData: CasinoBannersDataState;
}

export const CasinoBannersList = observer('CasinoBannersList', ({ casinoBannersData }: PropsType): JSX.Element => {
    const { errorMessageForList, isLoading, casinoBanners } = casinoBannersData;
    return (
        <>
            {errorMessageForList !== null && <ErrorMessageTop>{errorMessageForList}</ErrorMessageTop>}
            <ListContainer
                areLoading={isLoading}
                data-test='casino-banners-list'
            >
                <Loader isActive={isLoading} />
                {casinoBanners.map((banner: CasinoBannerType) => (
                    <SingleBanner
                        key={banner.id}
                        banner={banner}
                        casinoBannersState={casinoBannersData}
                    />
                ))}
            </ListContainer>
        </>
    );
});
